module.exports = __webpack_public_path__ + "img/dev-life.82dd33b5.png";